var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBookmarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166748 4.45801C0.166748 3.43029 0.575006 2.44467 1.30171 1.71797C2.02841 0.991266 3.01403 0.583008 4.04175 0.583008H16.9584C17.9861 0.583008 18.9718 0.991266 19.6985 1.71797C20.4252 2.44467 20.8334 3.43029 20.8334 4.45801V25.1608C20.8334 26.7367 19.0509 27.6538 17.7696 26.738L10.5001 21.5455L3.23058 26.738C1.94796 27.6551 0.166748 26.738 0.166748 25.1621V4.45801Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmarkFilled);
export default __webpack_public_path__ + "static/media/icon-bookmark-filled.62f36ee4d09db44c513b56242d3aeeda.svg";
export { ForwardRef as ReactComponent };